import Notification from '../shared/components/Notification';
import { NotificationTypes } from '../enums/notificationTypes';

const ASSET_DELETED_MESSAGE = 'One or more assets associated to this work order has been deleted';

// Keyed per order so selecting it and opening its details raise one popup, not two.
export const notifyAssetDeleted = (workOrderId: number) =>
  Notification({ message: ASSET_DELETED_MESSAGE, type: NotificationTypes.ERROR, key: `work-order-asset-deleted-${workOrderId}` });
